/**
* @Author: zachalam
* @Date:   2017-01-20T15:50:12-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-24T11:54:50-08:00
*/

import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import Login from '../components/pages/Login';
import { connect } from 'react-redux';
import { loginUserAction } from '../actions/authActions';
import { storeErrors, setLoading, clearErrors, clearEverything } from '../actions/commonActions';
import _ from 'lodash';

class LoginContainer extends Component {

  componentWillMount() {

    if(this.props.location.query.logged_out) {
      // check to see if attempting to logout
      // if so - clear everything.
      this.props.clearEverything();
    } else {
      // otherwise check to see if the user is already logged in
      // if they are - send them to the dashboard
      if(this.props.isAuthenticated) {
        // the user has a jwt, redirect them to the dashboard
        // if they have a profile, otherwise continue the join process.
        if(this.props.profile)
        browserHistory.push("/search");
        else
        browserHistory.push("/join-profile");
      }
    }
  }

  render() {
    return (
      <Login {...this.props} />
    );
  }
}


const mapStateToProps = (state) => {
    return {
      errors: state.common.errors,
      isAuthenticated: state.auth.isAuthenticated,
      profile: state.profile.profile
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {

    clearEverything: () => {
      dispatch(clearEverything());
    },
    loginUser: (username,password) => {

      dispatch(loginUserAction(username,password))
        .then((response) => {
        })
        .catch((error) => {
          try {
            let displayError = error.response.data.errors[0].detail;
            if(displayError)
              var theError = (<span>{displayError} If you believe this is a mistake, please contact <a href="http://support.misstravel.com/" target="_blank">customer support</a>.</span>);
            else {
              var theError = "Invalid username/password combination.";
            }
          } catch(e) {
            var theError = "Please enter a username and password.";
          }

          dispatch(storeErrors(theError));
          // hide loading
          dispatch(setLoading());
        });

    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(LoginContainer);



// WEBPACK FOOTER //
// ./src/containers/LoginContainer.jsx